<template>
  <div class="toggle-public-note">
    <div class="flex items-center justify-between mb-1">
      <span class="text-sm text-text-default">{{ translate('shareToWeb') }}</span>
      <ToggleButton
        :default-value="!!url"
        @click="handleToggleClick"
      />
    </div>
    <PublicPageListItem
      :url="url"
      :type="ResourceType.Note"
      :show-link-section="true"
    />
  </div>
</template>
<script setup lang="ts">
import PublicPageListItem from '@/components/widgets/PublicPageListItem';
import ToggleButton from '@/components/elements/ToggleButton';
import { ResourceType } from '@/types/resources';
import useTranslate from '@/utilities/composables/useTranslate';

const { translate } = useTranslate();

const emit = defineEmits(['click']);

defineProps({
  url: {
    type: String,
    required: true,
  },
});

const handleToggleClick = (value) => emit('click', value);
</script>
<style lang="scss">
.toggle-public-note {
  @apply w-[280px] box-border rounded-lg border border-solid bg-important-bg border-important-border p-4;

  box-shadow: 0px 4px 8px -2px rgba(16, 24, 40, 0.1);

  .public-page-item-section {
    @apply p-0;
  }
}
</style>
